export const ACTION_TYPES = {
    REQUEST_BANKS: 'REQUEST_BANKS',
    RECEIVE_BANKS: 'RECEIVE_BANKS'
  };
  
  const initialState = { entities: [], isLoading: false };
  
  export const bankActions = {
    requestBanks: () => async (dispatch) => {
    
      dispatch({ type: ACTION_TYPES.REQUEST_BANKS });
  
      const url = `api/bank`;
      const response = await fetch(url);
      const entities = await response.json();
  
      dispatch({ type: ACTION_TYPES.RECEIVE_BANKS, entities });
    }
  };
  
  export const reducer = (state, action) => {
    state = state || initialState;
  
    switch (action.type) {
      case (ACTION_TYPES.REQUEST_BANKS):
        return {
          ...state,
          isLoading: true
        };
        case (ACTION_TYPES.RECEIVE_BANKS):
        return {
          ...state,
          isLoading: false,
          entities: action.entities
        }
      default:
        return state;
    }
  
  };
  


// WEBPACK FOOTER //
// ./src/store/Bank.Reducer.js